var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-bg",style:('background:url(' + _vm.indata.bgcImage + ') no-repeat 50% 50%;')},[_c('p',{staticClass:"h1"},[_vm._v(_vm._s(_vm.indata.FirstTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }